var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024pt",
    height: "1023pt",
    viewBox: "0 0 1024 1023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 946.136719 492.234375 L 100.214844 2.96875 C 93.359375 -0.992188 84.855469 -0.992188 77.910156 2.96875 C 71.054688 6.929688 66.777344 14.265625 66.777344 22.226562 L 66.777344 1000.761719 C 66.777344 1008.722656 71.054688 1016.0625 77.910156 1020.019531 C 81.339844 1021.976562 85.210938 1022.996094 89.039062 1022.996094 C 92.914062 1022.996094 96.742188 1022.019531 100.214844 1020.019531 L 946.136719 530.75 C 952.992188 526.75 957.222656 519.410156 957.222656 511.492188 C 957.222656 503.578125 952.992188 496.195312 946.136719 492.234375 Z M 946.136719 492.234375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.a7794153c3d6f4426f624a3fc44ae928.svg";
export { ForwardRef as ReactComponent };